var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4135_34557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4135_34557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 35.0016C23.7833 35.0016 21.8958 34.2349 20.3375 32.7016C18.7792 31.1682 18 29.3016 18 27.1016C18 26.0182 18.2083 25.0057 18.625 24.0641C19.0417 23.1224 19.6167 22.2849 20.35 21.5516L24.95 17.0266C25.1 16.8932 25.2667 16.7891 25.45 16.7141C25.6333 16.6391 25.8167 16.6016 26 16.6016C26.1833 16.6016 26.3667 16.6391 26.55 16.7141C26.7333 16.7891 26.9 16.8932 27.05 17.0266L31.65 21.5516C32.3833 22.2849 32.9583 23.1224 33.375 24.0641C33.7917 25.0057 34 26.0182 34 27.1016C34 29.3016 33.2208 31.1682 31.6625 32.7016C30.1042 34.2349 28.2167 35.0016 26 35.0016ZM20.05 28.0016H31.9C32.1 26.8016 31.9875 25.7766 31.5625 24.9266C31.1375 24.0766 30.7 23.4349 30.25 23.0016L26 18.8016L21.75 23.0016C21.3 23.4349 20.8583 24.0766 20.425 24.9266C19.9917 25.7766 19.8667 26.8016 20.05 28.0016Z",
    fill: "#008685"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacity);
export default __webpack_public_path__ + "static/media/opacity.67dc20a330a3b860298db1b9393c196c.svg";
export { ForwardRef as ReactComponent };